var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyRecipients(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.500488,
    width: 80,
    height: 80,
    rx: 40,
    fill: "#DBE4F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.5009 39.9993C42.269 39.9993 43.9647 39.297 45.2149 38.0467C46.4651 36.7965 47.1675 35.1008 47.1675 33.3327C47.1675 31.5646 46.4651 29.8689 45.2149 28.6186C43.9647 27.3684 42.269 26.666 40.5009 26.666C38.7327 26.666 37.0371 27.3684 35.7868 28.6186C34.5366 29.8689 33.8342 31.5646 33.8342 33.3327C33.8342 35.1008 34.5366 36.7965 35.7868 38.0467C37.0371 39.297 38.7327 39.9993 40.5009 39.9993ZM40.5009 43.3327C33.8209 43.3327 28.3809 47.8127 28.3809 53.3327C28.3809 53.706 28.6742 53.9993 29.0475 53.9993H51.9542C52.3275 53.9993 52.6209 53.706 52.6209 53.3327C52.6209 47.8127 47.1809 43.3327 40.5009 43.3327Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyRecipients);
export default __webpack_public_path__ + "static/media/empty_recipients.53facc8169d29043d59c16f67c223513.svg";
export { ForwardRef as ReactComponent };